import moment, { Moment } from 'moment';
import { NButton, NDescriptions, NDescriptionsItem, NDivider, NEllipsis, NTag, NTooltip } from 'naive-ui';
import { mapState, mapStores } from 'pinia';
import { defineComponent } from 'vue';

import { useStationDetailStore } from '~/store/station-details.store';

import ComponentBase from '~/components/component-base';
import DeviceStatusDisplay from '~/components/device-status-display/device-status-display.vue';
import AvoltaMap from '~/components/leaflet-map/avolta-map.vue';

import StationEditionModal from '~/components/modals/station-edition-modal/station-edition-modal.vue';
import { AvoltaAlarm, AvoltaAlarmEnum } from '~/configs/alarms/avolta-alarm.model';
import { getStationAlarms } from '~/misc/station-utils';
import { dangerColor, greenColor, warningColor } from '~/variables';
import ExportDataModal from '~/components/modals/export-data-modal/export-data-modal.vue';

export default defineComponent({

    extends: ComponentBase,

    components: {

        AvoltaMap,
        DeviceStatusDisplay,
        StationEditionModal,
        ExportDataModal,

        NButton,
        NDescriptions,
        NDescriptionsItem,
        NDivider,
        NEllipsis,
        NTag,
        NTooltip,
    },

    data() {
        return {
            AvoltaAlarmEnum,
            greenColor,
            dangerColor,
            warningColor,

            moment,
        }
    },

    computed: {
        ...mapState(useStationDetailStore, ['station', 'since', 'before', 'measures']),
        ...mapStores(useStationDetailStore),

        created(): Moment | null {
            const ts = this.station?.metadata?.['elichens/public/created'];
            return ts ? moment.unix(ts / 1000) : null;
        },

        installation(): Moment | null {
            const ts = this.station?.metadata?.['elichens/public/installed'];
            return ts ? moment.unix(ts / 1000) : null;
        },

        alarms(): AvoltaAlarm[] {
            return getStationAlarms(this.station);
        }
    },

    methods: {
        onStationUpdated() {
            this.stationDetailsStore.refresh();
        }
    }
});